import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * ProtectedRoute component that replaces Next.js middleware
 * Checks for beta access cookie and redirects if not authenticated
 */
export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check for beta-access cookie
    const betaAccessCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('beta-access='));

    const hasAccess = betaAccessCookie?.split('=')[1] === 'authenticated';

    // Allow access to beta-access page
    if (location.pathname === '/beta-access') {
      return;
    }

    // Redirect to beta-access if no cookie
    if (!hasAccess) {
      const redirectPath = location.pathname !== '/' ? location.pathname : '';
      navigate(`/beta-access${redirectPath ? `?redirect=${encodeURIComponent(redirectPath)}` : ''}`);
    }
  }, [navigate, location.pathname]);

  // Allow beta-access page to render
  if (location.pathname === '/beta-access') {
    return <>{children}</>;
  }

  // Check cookie synchronously for initial render
  const betaAccessCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('beta-access='));
  const hasAccess = betaAccessCookie?.split('=')[1] === 'authenticated';

  if (!hasAccess) {
    return null; // Will redirect in useEffect
  }

  return <>{children}</>;
}
